import { Element } from '../core';
import type { ElementPlugin } from '../plugins';
import { ElementComponent } from './Element';
import { TextComponent } from './Text';
import type { RendererRenderElement, RendererRenderText } from './types';

export type ChildrenProps = Readonly<{
  node: ElementPlugin;
  renderElement: RendererRenderElement;
  renderText: RendererRenderText;
}>;

export const Children = ({ node, renderElement, renderText }: ChildrenProps): React.ReactNode => {
  const renderedChildren = node.children.map((n, i) => {
    if (Element.isElement(n)) {
      return (
        <ElementComponent key={i} node={n} renderElement={renderElement} renderText={renderText} />
      );
    } else {
      return <TextComponent key={i} node={n} renderText={renderText} />;
    }
  });

  return renderedChildren;
};
